import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiResponseModel, TypeformSurveyIdEnum, TypeformSurveyModel } from '@lms/shared/models';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TypeformSurveysService {
  constructor(private apiService: ApiService) {}

  getTypeformSurvey(typeformSurveyId: TypeformSurveyIdEnum): Observable<TypeformSurveyModel> {
    return this.apiService
      .executeGet<ApiResponseModel<TypeformSurveyModel>>(`typeform_surveys/${typeformSurveyId}`)
      .pipe(map(res => res.data));
  }
}
